import { render, staticRenderFns } from "./MailTemplateUpdateDialog.vue?vue&type=template&id=67f65bad&scoped=true"
import script from "./MailTemplateUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./MailTemplateUpdateDialog.vue?vue&type=script&lang=ts"
import style0 from "./MailTemplateUpdateDialog.vue?vue&type=style&index=0&id=67f65bad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f65bad",
  null
  
)

export default component.exports